import { graphql } from '@/gql';
import type { FetchSmsTemplatesQuery, FetchSmsTemplatesQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export type FetchSmsTemplatesInput = FetchSmsTemplatesQueryVariables;

export type FetchSmsTemplatesOutput = FetchSmsTemplatesQuery['smsTemplates'];

export const fetchSmsTemplates = async ({ name, pagination }: FetchSmsTemplatesInput): Promise<FetchSmsTemplatesOutput> => {
  const response = await queryExecute({
    query: graphql(`
      query FetchSmsTemplates($pagination: PaginationInputType, $name: String) {
        smsTemplates(pagination: $pagination, name: $name) {
          rows {
            id
            name
            template
            createdAt
            updatedAt
          }
          count
        }
      }
    `),
    variables: {
      name,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.smsTemplates;
};
